







































import { defineComponent, useContext, useMeta } from '@nuxtjs/composition-api'
import { useBreadcrumb } from '~/composables/ui/useBreadcrumb'
import { useBreadcrumbsSchemaScript } from '~/composables/useSchemaScript'

export default defineComponent({
  name: 'PagesLogin',
  layout: 'login',

  middleware: ['authed'],
  setup() {
    const { i18n } = useContext()
    const { breadcrumbs, setBreadcrumbs } = useBreadcrumb()
    const { breadcrumbsSchemaScript, setBreadcrumbsSchemaScript } =
      useBreadcrumbsSchemaScript()

    setBreadcrumbs([
      {
        label: i18n.t('common.text.register') as string,
      },
    ])
    setBreadcrumbsSchemaScript(breadcrumbs.value!)

    useMeta(() => {
      return breadcrumbsSchemaScript.value
        ? {
            script: [breadcrumbsSchemaScript.value],
          }
        : {}
    })
  },

  head: {},
})
